export default {
  computed: {
    qingsuChannelConfig() {
      const { qingsuChannelConfig } = this.$store.state
      if (!qingsuChannelConfig?.config) return {}
      const config = qingsuChannelConfig.config
      return config.content
    },
    toWechatAuth() {
      const arr = Array.isArray(this.qingsuChannelConfig.wechatAuthCids)
        ? this.qingsuChannelConfig.wechatAuthCids
        : [209]
      const { cid } = this.$route.query
      return (
        this.$platform.isWechat &&
        !this.isWebviewMp &&
        !!arr.find(v => +v === +cid)
      )
    }
  }
}
